import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "./app/AppProviders";
import { AppRouter } from "./app/AppRouter";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/workspace.css";
import "./styles/print.css";
import "./styles/report.css";
import "./styles/wholesale.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html must contain a #root element");
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);

// The service worker (`public/sw.js`: hashed assets and the brand files
// cache-first, navigations network-first with an offline document, the API
// never cached) makes the site installable. Production builds only: under Vite's dev server it would
// keep serving a stale document between edits. After `load`, so registering
// never competes with the first paint; the app is whole without it.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Refused (private browsing, a policy) — the site simply is not installable here.
    });
  });
}
